// Auto-generated branded ID types — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.

export type AiCreditAccountId = string & { readonly __brand: 'AiCreditAccountId' };
export const AiCreditAccountId = (value: string): AiCreditAccountId => value as AiCreditAccountId;

export type AiReviewId = string & { readonly __brand: 'AiReviewId' };
export const AiReviewId = (value: string): AiReviewId => value as AiReviewId;

export type MagicLinkRequestId = string & { readonly __brand: 'MagicLinkRequestId' };
export const MagicLinkRequestId = (value: string): MagicLinkRequestId => value as MagicLinkRequestId;

export type MasteryPlanId = string & { readonly __brand: 'MasteryPlanId' };
export const MasteryPlanId = (value: string): MasteryPlanId => value as MasteryPlanId;

export type PremiumWaitlistId = string & { readonly __brand: 'PremiumWaitlistId' };
export const PremiumWaitlistId = (value: string): PremiumWaitlistId => value as PremiumWaitlistId;

export type RecordingId = string & { readonly __brand: 'RecordingId' };
export const RecordingId = (value: string): RecordingId => value as RecordingId;

export type SeriesId = string & { readonly __brand: 'SeriesId' };
export const SeriesId = (value: string): SeriesId => value as SeriesId;

export type UserId = string & { readonly __brand: 'UserId' };
export const UserId = (value: string): UserId => value as UserId;

